/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownFromDoubleLine: {
  name: 'arrow-down-from-double-line';
  data: string;
} = {
  name: 'arrow-down-from-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 1A.5.5 0 0 1 3 .5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5Zm5 3.5v9.293L3.354 9.646a.5.5 0 1 0-.708.708l5 5a.5.5 0 0 0 .708 0l5-5a.5.5 0 0 0-.708-.708L8.5 13.793V4.5H13a.5.5 0 0 0 0-1H3a.5.5 0 0 0 0 1h4.5Z" fill="currentColor"/></svg>`,
};
